import { render, staticRenderFns } from "./CreateAskedQuestions.vue?vue&type=template&id=1b6da022&scoped=true&"
import script from "./CreateAskedQuestions.vue?vue&type=script&lang=js&"
export * from "./CreateAskedQuestions.vue?vue&type=script&lang=js&"
import style0 from "./CreateAskedQuestions.vue?vue&type=style&index=0&id=1b6da022&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6da022",
  null
  
)

export default component.exports